/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:c50c6cf3-c1a7-49a3-a7ef-efb051fdd617",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_sabdGYCHO",
    "aws_user_pools_web_client_id": "6d89iinnv7i8hbdhn4p78akidr",
    "oauth": {},
    "aws_user_files_s3_bucket": "pedigree230605-dev",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://t56wj6ew6fa3xi3fnsbovaopv4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_content_delivery_bucket": "pharmpak-prod-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://dmdnxs7iqx5o1.cloudfront.net"
};


export default awsmobile;
